import { px2rem } from "../../utils/size";
import styled from "styled-components";
const bgImg = "https://i.ezbuy.sg/FtsfGGkCePHOP1yLX4C3mPbF9ToR";
const btnImg = "https://i.ezbuy.sg/FjjcTUkAAveOdvBOMbefKWxc64GJ";
export const GamesBanner = styled.img `
	width: ${px2rem(351)};
	height: ${px2rem(80)};
	margin: 0 ${px2rem(12)};
	border-radius: ${px2rem(4)};
`;
export const GamesBackground = styled.div `
	width: ${px2rem(381)};
	height: ${px2rem(373)};
	background-image: url(${bgImg});
	background-size: cover;
	margin: 0 auto;
	display: flex;
	align-items: center;
	justify-content: center;
	font-family: var(--fontBold);
	text-align: center;
	flex-direction: column;
`;
export const GamesTitle = styled.div `
	width: ${px2rem(122.5)};
	height: ${px2rem(21.5)};
	font-size: ${px2rem(18)};
	font-weight: bold;
	color: #333333;
	line-height: ${px2rem(21.5)};
	padding-bottom: ${px2rem(192)};
	margin-top: ${px2rem(40)};
`;
export const GamesSubtitle = styled.div `
	width: ${px2rem(200)};
	height: ${px2rem(17)};
	font-size: ${px2rem(14)};
	font-weight: 400;
	color: #40414c;
	line-height: ${px2rem(17)};
`;
export const GamesButton = styled.div `
	width: ${px2rem(290)};
	height: ${px2rem(44)};
	background-image: url(${btnImg});
	background-size: cover;
	margin: 0 auto;
	margin-top: ${px2rem(15.5)};
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: ${px2rem(15)};
	font-family: var(--fontBold);
	font-weight: 600;
	color: #993902;
	line-height: ${px2rem(14.5)};
`;
